var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66212 15.1067C7.90076 14.9206 8.11722 14.7041 8.55008 14.2713L14.097 8.72438C13.342 8.41017 12.4479 7.89404 11.6022 7.0484C10.7565 6.20263 10.2403 5.30833 9.92612 4.55332L4.37912 10.1003L4.37907 10.1004C3.94624 10.5332 3.7298 10.7496 3.54367 10.9883C3.3241 11.2698 3.13585 11.5744 2.98226 11.8967C2.85205 12.1699 2.75526 12.4602 2.56167 13.041L1.54084 16.1035C1.44557 16.3893 1.51995 16.7044 1.73297 16.9174C1.94599 17.1304 2.26108 17.2048 2.54688 17.1096L5.60938 16.0887C6.19014 15.8951 6.48052 15.7983 6.75373 15.6681C7.07602 15.5145 7.38061 15.3263 7.66212 15.1067Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6362 7.18518C16.7879 6.0334 16.7879 4.166 15.6362 3.01422C14.4844 1.86245 12.617 1.86245 11.4652 3.01422L10.7999 3.6795C10.809 3.70701 10.8185 3.7349 10.8283 3.76316C11.0721 4.46601 11.5322 5.3874 12.3977 6.25291C13.2632 7.11842 14.1846 7.5785 14.8875 7.82235C14.9156 7.83211 14.9434 7.84152 14.9708 7.85059L15.6362 7.18518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenWhite);
export default __webpack_public_path__ + "static/media/pen-white.2e10b968d00d5c6c052b0999d03258a8.svg";
export { ForwardRef as ReactComponent };